import React from "react";
import "./tile.scss";
import classNames from "classnames";
import { TileModel } from "../../../helpers/tile";

interface TileProps {
  tile: TileModel;
  isSelected: boolean;
  onClick: (type: string) => void;
  hasError?: boolean;
}

export default function Tile(props: TileProps): React.ReactElement<TileProps> {
  return (
    <div className={classNames("tile", props.tile.id.toLowerCase(), { "is-selected": props.isSelected })}
      onClick={() => props.onClick(props.tile.id)}>
      <div className={classNames("icon", { "has-error": props.hasError })}>
        {props.tile.icon}
      </div>
      <div className="display-name">{props.tile.displayName}</div>
    </div>
  );
}
